import { render, staticRenderFns } from "./asdkfew.vue?vue&type=template&id=9398f7ec&"
import script from "./asdkfew.vue?vue&type=script&lang=js&"
export * from "./asdkfew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports